import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import { useTranslation } from 'react-i18next';

import Login from './Login/Login';
import LoginOTP from './LoginOTP/LoginOTP';
import Loader from '../components/Loader/Loader';

function Pages() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const [locationErr, setLocationError] = useState(false);
    const { t } = useTranslation();


    useEffect(() => {
        const fetchLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        dispatch({
                            type: "UPDATE_LOCATION",
                            payload: {
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude,
                                locationEnabled: true
                            }
                        });
                        setLocationError(false);
                    },
                    (error) => {
                        console.error('Error getting location:', error.message);
                        setLocationError(true);
                        dispatch({ type: "UPDATE_LOCATION", payload: { latitude: '', longitude: '', locationEnabled: false } });
                    }
                );
            } else {
                console.error('Geolocation is not supported by this browser');
            }
        }

        fetchLocation();
    }, [dispatch]);

    return (
        <>
            <Loader />
            {locationErr && (
                <div className={`alert alert-danger ${state.rtl ? 'text-right' : ''}`} role="alert">
                    {t("Enable_your_location")}
                </div>
            )}

            {state.loginActive ? (
                <Login />
            ) : (
                <LoginOTP />
            )}
        </>
    )
}

export default Pages